export default "__VITE_ASSET__rap69Y6b__"